<template>
    <div :style="{height:formDivHeight+'px',overflow: 'auto'}">
        <el-form :model="permissionForm" :rules="formRules" label-position="right" ref="permissionFormEl" label-width="100px" class="demo-ruleForm">
            <el-input  v-model="permissionForm.parentPermissionPid" type="hidden"></el-input>
            <el-form-item label="上级菜单" prop="perpermissionName">
                <el-input style="width: 98%" v-model="permissionForm.perpermissionName" @click.native="showSelectTwoLevelDialog()" suffix-icon="el-icon-search"  :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="菜单名称" prop="permissionName">
                <el-input v-model="permissionForm.permissionName" style="width: 98%" placeholder="输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="菜单排序" prop="permissionIndex">
                <el-input v-model="permissionForm.permissionIndex" style="width: 98%" placeholder="输入模块排序"></el-input>
            </el-form-item>
            <el-form-item label="所属终端" prop="permissionType">
                <el-select v-model="permissionForm.permissionType"  style="width: 98%" placeholder="选择所属终端">
                    <el-option
                            v-for="item in typeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div style="text-align: center">
            <el-button type="primary" style="width: 100px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 100px" @click="closeWindow()">关闭</el-button>
        </div>
        <!--dialog-->
        <el-dialog
                title="选择一级菜单"
                width="430px"
                :visible.sync="dialogisview"
                append-to-body
                direction="rtl">
            <SelectTwoLevelDialog ref="selectTwoLevelDialog" :setSelectedPermission="setSelectedPermission"></SelectTwoLevelDialog>
        </el-dialog>
    </div>
</template>
<script>
    import SelectTwoLevelDialog from "./SelectTwoLevelDialog.vue";
    import {appjs} from "@/utiljs/apputil";
    export default {
        components:{
            SelectTwoLevelDialog
        },
        props: {
            closeWindow: {
                type: Function
            },
            selectedPerData:{
                type: Object
            }
        },
        data() {
            return {
                dialogisview:false,
                formDivHeight: (document.documentElement.clientHeight-100),
                saveButValue: '保 存',
                saveButState: false,
                permissionForm: {
                    perpermissionName:'',
                    parentPermissionPid: '',
                    permissionPid:'',
                    permissionMenu: '',
                    permissionName: '',
                    permissionUrl:'',
                    permissionImage:'',
                    permissionType: '',
                    permissionIndex: '',
                    permissionRemark:''
                },
                formRules: {
                    permissionName: [
                        { required: true, message: '请输入菜单名称', trigger: 'blur' }
                    ],
                    permissionIndex: [
                        { required: true, message: '请输入菜单排序', trigger: 'blur' }
                    ],
                    permissionType: [
                        { required: true, message: '请选择所属终端', trigger: 'blur' }
                    ]
                },
                typeOptions:[
                    {value:'m',label:'移动端'},
                    {value:'p',label:'PC端'}
                ]
            }
        },
        created() {
            this.resertForm();
        },
        methods:{
            resertForm() {
                this.saveButValue = '更 新';
                this.saveButState = false;
                this.formDivHeight = (document.documentElement.clientHeight-100);
                if(this.$refs['permissionFormEl']){
                    this.$refs['permissionFormEl'].resetFields();
                }
                this.permissionForm.permissionPid = this.selectedPerData.permissionpid;
                this.permissionForm.parentPermissionPid = this.selectedPerData.parentpermissionpid;
                this.permissionForm.perpermissionName = this.selectedPerData.parentpermissionname;
                this.permissionForm.permissionMenu = this.selectedPerData.permissionmenu;
                this.permissionForm.permissionName = this.selectedPerData.permissionname;
                this.permissionForm.permissionUrl = appjs.HTMLDecode(this.selectedPerData.permissionurl);
                this.permissionForm.permissionImage = this.selectedPerData.permissionimage;
                this.permissionForm.permissionType = this.selectedPerData.permissiontype;
                this.permissionForm.permissionIndex = this.selectedPerData.permissionindex;
                this.permissionForm.permissionRemark = this.selectedPerData.permissionremark;
            },
            showSelectTwoLevelDialog(){
                if(this.permissionForm.perpermissionName=="功能菜单"){
                    appjs.showErrorMsg("一级菜单不能修改")
                    return;
                }
                this.dialogisview = true;
            },
            setSelectedPermission(seldata){
                this.permissionForm.parentPermissionPid = seldata.permissionpid;
                this.permissionForm.perpermissionName = seldata.permissionname;
                this.dialogisview = false;
            },
            submitForm() {
                this.$refs.permissionFormEl.validate((valid) => {
                    if (valid) {
                        let params = this.permissionForm;
                        this.saveButValue = '更新中....'
                        this.saveButState = true;
                        let _self = this;
                        appjs.httpRequest('permission/updatePermission',params).then((data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.showErrorMsg(data.retMsg);
                                _self.saveButValue = '更 新';
                                _self.saveButState = false;
                            }else{
                                _self.saveButValue = '更新成功';
                                _self.closeWindow(data.retMsg);
                            }
                        }).catch((error)=>{
                            _self.saveButState = false;
                            _self.loginText = '更 新';
                            appjs.showErrorMsg("异常：" + error)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>
